"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetalenForm = void 0;
var react_1 = __importDefault(require("react"));
function BetalenForm(_a) {
    var onSubmit = _a.onSubmit;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h4", { className: "card-title" }, "Betalen"),
        react_1.default.createElement("div", { className: "form-row" },
            react_1.default.createElement("div", { className: "col-md-6 text-center" },
                react_1.default.createElement("button", { type: "submit", name: "betaling", value: "ideal", className: "btn btn-blue btn-md-block mb-2", onClick: onSubmit("ideal") },
                    react_1.default.createElement("i", { className: "fab fa-ideal fa-3x" }),
                    react_1.default.createElement("br", null),
                    "Direct betalen met IDeal")),
            react_1.default.createElement("div", { className: "col-md-6 text-center" },
                react_1.default.createElement("button", { type: "submit", name: "betaling", value: "factuur", className: "btn btn-green2 btn-md-block mb-2", onClick: onSubmit("factuur") },
                    react_1.default.createElement("i", { className: "fas fa-file-invoice fa-3x" }),
                    react_1.default.createElement("br", null),
                    "Factuur ontvangen en later betalen")))));
}
exports.BetalenForm = BetalenForm;
